import React, { Fragment } from 'react';
import { Row, Col, Alert } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import { MyContext } from '../../InitialSetup/MyProvider';
import { Helmet } from "react-helmet";
import { Utilities, _Map } from '../../Utilities/Utilities';
import { downloadContestTeam, getContestLeaderboard, getOwnLeaderboard, getLineupWithScore,getOwnLeaderboardNF,downloadContestTeamNF,getContestLeaderboardNF,getLineupWithScoreNF,getContestScoreCard,getContestScoreCardNF  } from '../../WSHelper/WSCallings';
import { NoDataView } from '../../Component/CustomComponent';
import { AppSelectedSport, SELECTED_GAMET, GameType } from '../../helper/Constants';
import Images from '../../components/images';
import MyLeaderboardItem from "./MyLeaderboardItem";
import MetaData from "../../helper/MetaData";
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import CustomHeader from '../../components/CustomHeader';
import FieldView from "./../FieldView";
import * as AppLabels from "../../helper/AppLabels";
import * as NC from "../../WSHelper/WSConstants";
import * as WSC from "../../WSHelper/WSConstants";
import { Sports } from '../../JsonFiles';

/**
  * @description This is the header of other user rank list.
  * @return UI components
  * @param context This is the instance of this component
*/
const ListHeader = ({ context }) => {
    return (
        <div className="ranking-list user-list-header" style={context.state.userRankList.length == 0 ? { marginTop: 0 } : {}}>
            <div className="display-table-cell text-center">
                <div className="list-header-text">{AppLabels.RANK}</div>
            </div>
            <div className="display-table-cell pl-1">
                <div className="list-header-text left pl6">{AppLabels.NAME}</div>
            </div>
            <div className="display-table-cell">
                <div className="list-header-text text-right mr10">{AppLabels.POINTS}</div>
            </div>
        </div>
    )
}

const Shimmer = () => {
    return (
        <div className="ranking-list shimmer margin-2p">
            <div className="display-table-cell text-center">
                <div className="rank">--</div>
                <div className="rank-heading">{AppLabels.RANK}</div>
            </div>
            <div className="display-table-cell pl-1 pointer-cursor">
                <figure className="user-img shimmer">
                    <Skeleton circle={true} width={40} height={40} />
                </figure>
                <div className="user-name-container shimmer">
                    <Skeleton width={'80%'} height={8} />
                    <Skeleton width={'40%'} height={5} />
                </div>
            </div>
            <div className="display-table-cell">
                <div className="points">--</div>
            </div>
        </div>
    )
}

export default class LeaderBoard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaderShow: false,
            isLoadMoreLoaderShow: false,
            hasMore: true,
            leaderboardList: [],
            userRankList: [],
            ShimmerList: [1, 2, 3, 4, 5, 1, 2, 3, 4, 5, 1, 2, 3, 4, 5],
            status: '',
            contestItem: '',
            contestId: '',
            rootItem: '',
            mfileURL: '',
            downloadFail: false,
            isExpanded: false,
            isExpandedWithDelay: false,
            pageNo: 1,
            page_size: 20,
            AllLineUPData: {},
            SelectedLineup: '',
            showFieldV: false,
            isRefresh: false,
            UserName: '',
            scoreCardData:[],
            youData: '',
            oppData: '',
            IsNetworkGameContest:false
        }
        this.headerRef = React.createRef();
    }

    UNSAFE_componentWillMount() {
        if (this.props.location.state) {
            this.setState({
                status: this.props.location.state.status,
                contestItem: this.props.location.state.contestItem,
                contestId: this.props.location.state.contestItem.contest_id,
                rootItem: this.props.location.state.rootItem,
            })
        } else {
            this.props.history.push("/lobby#" + Utilities.getSelectedSportsForUrl());
        }
    }

    goBack() {
        this.props.history.goBack();
    }

    componentDidMount() {
        if (this.props.location.state) {
            this.getContestScoreCardData();
            this.getLeaderboard();
            this.getUserRank()
            if (this.headerRef) {
                this.headerRef.GetHeaderProps('', {}, {}, this.state.rootItem);
            }
        }
    }

    onLoadMore() {
        if (!this.state.isLoaderShow && this.state.hasMore) {
            this.setState({ hasMore: false })
            this.getLeaderboard()
        }
    }

    /**
     * 
     * @description method to refresh page contest when user pull down to refresh screen
     */
    handleRefresh = () => {
        if (!this.state.isLoaderShow) {
            this.setState({ hasMore: false, pageNo: 1, isRefresh: true }, () => {
                this.hideFieldV();
                this.getLeaderboard();
                this.getUserRank()
            })
        }
    }

    getUserRank() {
        let param = {
            "sports_id": AppSelectedSport,
            "contest_id": this.state.contestId,
        }
        let IsNetworkFantasy = this.props && this.props.location && this.props.location.state && this.props.location.state.contestItem && this.props.location.state.contestItem.is_network_contest == 1
        if(IsNetworkFantasy){
            getOwnLeaderboardNF(param).then((responseJson) => {
                if (responseJson && responseJson.response_code == NC.successCode) {
                    this.setState({ userRankList: responseJson.data });
                }
            })
        }
        else{
            getOwnLeaderboard(param).then((responseJson) => {
                if (responseJson && responseJson.response_code == NC.successCode) {
                    let data = responseJson.data;
                    this.setState({ 
                        userRankList: data, 
                        youData: data[0] 
                    });
                }
            })
        }
    }

    getLeaderboard() {
        let param = {
            "sports_id": AppSelectedSport,
            "contest_id": this.state.contestId,
            "page_size": this.state.page_size,
            "page_no": this.state.pageNo
        }
        this.setState({ isLoaderShow: true })
        let IsNetworkFantasy = this.props && this.props.location && this.props.location.state && this.props.location.state.contestItem && this.props.location.state.contestItem.is_network_contest == 1;
        if(IsNetworkFantasy){
            getContestLeaderboardNF(param).then((responseJson) => {
                this.setState({ isLoaderShow: false })
                setTimeout(() => {
                    this.setState({
                        isRefresh: false
                    })
                }, 2000);
                if (responseJson && responseJson.response_code == NC.successCode) {
                    this.setState({
                        leaderboardList: this.state.pageNo == 1 ? responseJson.data : [...this.state.leaderboardList, ...responseJson.data],
                        hasMore: responseJson.data.length === this.state.page_size,
                        pageNo: this.state.pageNo + 1
                    });
                }
            })
        }
        else{
            getContestLeaderboard(param).then((responseJson) => {
                this.setState({ isLoaderShow: false })
                setTimeout(() => {
                    this.setState({
                        isRefresh: false
                    })
                }, 2000);
                if (responseJson && responseJson.response_code == NC.successCode) {
                    this.setState({
                        leaderboardList: this.state.pageNo == 1 ? responseJson.data : [...this.state.leaderboardList, ...responseJson.data],
                        hasMore: responseJson.data.length === this.state.page_size,
                        pageNo: this.state.pageNo + 1
                    });
                }
            })
        }
    }
    async getContestScoreCardData() {
        let param = {
            "sports_id": AppSelectedSport,
            "contest_id": this.state.contestId,
        }
        this.setState({ isLoaderShow: true })
        let IsNetworkFantasy = this.props && this.props.location && this.props.location.state && this.props.location.state.contestItem && this.props.location.state.contestItem.is_network_contest == 1;
        let apiCall = IsNetworkFantasy ? getContestScoreCardNF : getContestScoreCard;
        await apiCall(param).then((responseJson) => {
            this.setState({ isLoaderShow: false })

            if (responseJson && responseJson.response_code == NC.successCode) {
                this.setState({ scoreCardData: responseJson.data })
            }
        })
    }
    showScoreCard = (item, status) => {
        return (
            <>
                {
                    status == 1 &&
                    <div className="score-card-header">
                        <div className="left-right-section">
                            <div className="team-left">
                                <div className="display-score-card">
                                    <div className="contest-details-first-div">{item.home ? item.home : ''}</div>
                                    {
                                        AppSelectedSport == Sports.cricket ?
                                            item.score_data && item.score_data[1] ?
                                                <div className="contest-details-sec-div">
                                                    {item.score_data[1].home_team_score}-{(item.score_data[1].home_wickets) ? item.score_data[1].home_wickets : 0}
                                                    <span className="gray-color-class"> {(item.score_data[1].home_overs) ? item.score_data[1].home_overs : 0} {item.score_data[2] ? ' & ' : ''} </span>
                                                    {
                                                        item.score_data[2] && <div className="contest-details-sec-div second-inning">
                                                            {item.score_data[2].home_team_score}-{(item.score_data[2].home_wickets) ? item.score_data[2].home_wickets : 0}
                                                            <span className="gray-color-class"> {(item.score_data[2].home_overs) ? item.score_data[2].home_overs : 0} </span>
                                                        </div>
                                                    }
                                                </div>
                                                :
                                                <div className="contest-details-sec-div">{0}-{0}<span className="gray-color-class"> 0 </span></div>
                                            :
                                            (item.score_data) ?
                                                <div className="contest-details-sec-div">{item.score_data.home_score}</div>
                                                :
                                                <div className="contest-details-sec-div">0</div>
                                    }
                                </div>
                            </div>
                            <div className="team-right">
                                <div className="display-score-card">
                                    <div className="contest-details-first-div">{item.away ? item.away : ''}</div>
                                    {
                                        AppSelectedSport == Sports.cricket ?
                                            item.score_data && item.score_data[1] ?
                                                <div className="contest-details-sec-div">
                                                    {item.score_data[1].away_team_score}-{(item.score_data[1].away_wickets) ? item.score_data[1].away_wickets : 0}
                                                    <span className="gray-color-class"> {(item.score_data[1].away_overs) ? item.score_data[1].away_overs : 0} {item.score_data[2] ? ' & ' : ''} </span>
                                                    {
                                                        item.score_data[2] && <div className="contest-details-sec-div second-inning">
                                                            {item.score_data[2].away_team_score}-{(item.score_data[2].away_wickets) ? item.score_data[2].away_wickets : 0}
                                                            <span className="gray-color-class"> {(item.score_data[2].away_overs) ? item.score_data[2].away_overs : 0} </span>
                                                        </div>
                                                    }
                                                </div>
                                                :
                                                <div className="contest-details-sec-div">{0}-{0}<span className="gray-color-class"> 0 </span></div>
                                            :
                                            (item.score_data) ?
                                                <div className="contest-details-sec-div">{item.score_data.away_score}</div>
                                                :
                                                <div className="contest-details-sec-div">0</div>


                                    }
                                </div>
                            </div>
                        </div>
                                <div className="middle-header-content">{AppLabels.RANK_UPDATED_TEXT}</div>
                    </div>
                }
            </>
        )
    }
    onDownloadClick() {
        if (!this.state.isLoaderShow) {
            var param = {
                "sports_id": AppSelectedSport,
                "contest_id": this.state.contestId,
            }
            this.setState({ isLoaderShow: true })
            if(this.state.contestItem && this.state.contestItem.is_network_contest != 1){
                downloadContestTeam(param).then((responseJson) => {
                    this.setState({ isLoaderShow: false })
                    if (responseJson.response_code == NC.successCode) {
                        if (responseJson.data.uploaded && responseJson.data.file) {
                            this.downloadFile(responseJson.data.file);
                            this.setState({ mfileURL: responseJson.data.file })
                        }
                    }
                })
            }
            else{
                downloadContestTeamNF(param).then((responseJson) => {
                    this.setState({ isLoaderShow: false })
                    if (responseJson.response_code == NC.successCode) {
                        if (responseJson.data.uploaded && responseJson.data.file) {
                            this.downloadFile(responseJson.data.file);
                            this.setState({ mfileURL: responseJson.data.file })
                        }
                    }
                })
            }
        }

    }

    downloadFile(fileURL) {
        var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        if (!window.ActiveXObject) {

            if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                save.download = filename;
                document.location = save.href;
            }
            else if (navigator.userAgent.toLowerCase().match(/(android)/)) {
                if (window.ReactNativeWebView) {
                    let data = {
                        action: 'download',
                        targetFunc: 'download',
                        type: 'team',
                        url: fileURL
                    }
                    this.sendMessageToApp(data);
                }
                else {
                    let save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';

                    save.download = filename;
                    var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    save.dispatchEvent(evt);
                    (window.URL || window.webkitURL).revokeObjectURL(save.href);
                }
            }
            else {
                var popup_window = window.open(fileURL, "_blank");
                try {
                    popup_window.focus();
                } catch (e) {
                    this.setState({ downloadFail: true })
                }


            }
        }
        // for IE < 11
        else if (!!window.ActiveXObject && document.execCommand) {
            var _window = window.open(fileURL, '_blank');
            _window.document.close();
            _window.document.execCommand('SaveAs', true, filename)
            _window.close();
        }

    }

    sendMessageToApp(action) {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify(action));
        }
    }

    /**
     * @description This function is used to open player lineup page with formatted URL data
     * @param teamItem Team item
     * @see FieldView
    */
    openLineup = (e,teamItem,youTeam) => {
        let IsNetworkFantasy = this.props && this.props.location && this.props.location.state && this.props.location.state.contestItem && this.props.location.state.contestItem.is_network_contest == 1;
            
        if(SELECTED_GAMET == GameType.DFS && youTeam!=3 && !IsNetworkFantasy){
            if(youTeam==1){
                this.TeamComparison(e,teamItem,'')
            }
            else{
                this.TeamComparison(e,'',teamItem)
            }
        }
        else{
            this.setState({
                SelectedLineup: teamItem.lineup_master_contest_id,
                UserName: teamItem.user_name || ''
            }, () => {
                this.getLineupScoreData(teamItem)
            })
        }
    }

    getLineupScoreData = (teamItem) => {

        let lineupData = this.state.AllLineUPData && this.state.AllLineUPData[this.state.SelectedLineup] ? this.state.AllLineUPData[this.state.SelectedLineup] : ''
        if (lineupData) {
            this.showFieldV()
        } else {
            let param = {
                'lineup_master_contest_id': teamItem.lineup_master_contest_id,
                "sports_id": AppSelectedSport,
            }
            let IsNetworkFantasy = this.props && this.props.location && this.props.location.state && this.props.location.state.contestItem && this.props.location.state.contestItem.is_network_contest == 1;
            let apiCall = IsNetworkFantasy ? getLineupWithScoreNF : getLineupWithScore;
            apiCall(param).then((responseJson) => {
                if (responseJson.response_code == WSC.successCode) {

                    let lData = this.state.AllLineUPData;
                    lData[teamItem.lineup_master_contest_id] = responseJson.data;
                    this.setState({
                        AllLineUPData: lData,
                        IsNetworkGameContest:IsNetworkFantasy
                    }, () => {
                        this.showFieldV()
                    })
                }
            })

          
        }
    }

    showFieldV = () => {
        this.setState({
            showFieldV: true
        });
    }
    hideFieldV = () => {
        this.setState({
            showFieldV: false,
            SelectedLineup: ''
        });
    }

    copyToClipboard = (textToCopy) => {
        var textField = document.createElement('textarea')
        textField.innerText = textToCopy
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()
        Utilities.showToast(AppLabels.URL_COPIED_TO_CLIPBOARD, 5000)
        setTimeout(() => {
            this.setState({ downloadFail: false })
        }, 1000 * 30);
    }

    TeamComparison=(e,youTeam,otherTeam)=>{
        let UT = youTeam == '' ? this.state.youData : youTeam;
        let OT = otherTeam != '' ? otherTeam : this.state.oppData;
        e.stopPropagation();    
        this.setState({
            youData: UT,
            oppData: OT
        },()=>{
            if(UT.user_name == OT.user_name){
                Utilities.showToast(AppLabels.YOU_CANT_COMPARE_YOU_OWN_TEAMS, 2500);
                this.setState({
                    oppData: ''
                })
            }
            else if(this.state.youData && this.state.oppData){
                this.props.history.push({ 
                    pathname: "/team-comparison", 
                    state: {oppData:OT,status: this.state.status,youData: UT,userRankList: this.state.userRankList, selectedContest: this.state.contestItem}
                });
            }
        })
    }

    render() {
        const HeaderOption = {
            back: true,
            fixture: false,
            status: this.state.status,
            hideShadow: true,
            leaderboard: true,
        }
        let lineupData = this.state.AllLineUPData && this.state.AllLineUPData[this.state.SelectedLineup] ? this.state.AllLineUPData[this.state.SelectedLineup] : ''
        let item = this.state.scoreCardData && this.state.scoreCardData.length > 0 ? this.state.scoreCardData[0] : [];

        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="web-container web-container-fixed">
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.leaderboard.title}</title>
                            <meta name="description" content={MetaData.leaderboard.description} />
                            <meta name="keywords" content={MetaData.leaderboard.keywords}></meta>
                        </Helmet>
                        <CustomHeader
                            ref={(ref) => this.headerRef = ref}
                            HeaderOption={HeaderOption}
                            {...this.props} />
                        <Row>
                            <Col sm={12}>
                                 <div className="leaderboard-wrapper">
                                    {
                                        (this.state.userRankList.length == 0 && this.state.leaderboardList.length == 0 && this.state.isLoaderShow) ?
                                            this.state.ShimmerList.map((item, index) => {
                                                return (
                                                    <Shimmer key={index} />
                                                )
                                            })
                                            :
                                            (this.state.userRankList.length == 0 && this.state.leaderboardList.length == 0 && !this.state.isLoaderShow) ?
                                                <NoDataView
                                                    BG_IMAGE={Images.no_data_bg_image}
                                                    CENTER_IMAGE={Images.teams_ic}
                                                    MESSAGE_1={AppLabels.NO_DATA_AVAILABLE}
                                                    MESSAGE_2={''}
                                                    BUTTON_TEXT={AppLabels.GO_TO_MY_CONTEST}
                                                    onClick={this.goBack.bind(this)}
                                                />
                                                :


                                                <div>
                                                    {this.state.rootItem.scoring_alert && this.state.rootItem.scoring_alert != '0' &&
                                                        <Alert variant="warning" className="alert-warning msg-alert-container border-radius-0">
                                                            <div className="msg-alert-wrapper">
                                                                <span className=""><i className="icon-megaphone"></i></span>
                                                                <span>{AppLabels.CUSTOM_SCORING_MSG}</span>
                                                            </div>
                                                        </Alert>
                                                    }
                                                     {
                                                            this.showScoreCard(item, this.state.status)
                                                    }
                                                   
                                                    <div className={"leaderboard-header"+ (this.state.status != 1 ? ' top-completed': '' )}>
                                                       
                                                        {
                                                            
                                                            this.state.userRankList.length > 0 &&
                                                            <Fragment>
                                                                <div className={"leaderboard-header " + (this.state.isExpanded ? "collpased-header-list-show" : "collpased-header-list-hide")} style={this.state.isExpanded ? { height: this.state.userRankList.length > 2 ? 126 : 100, overflow: 'auto' } : { height: 70 }}>
                                                                    <div>
                                                                        {
                                                                            this.state.userRankList.length > 0 &&
                                                                            _Map(this.state.userRankList, (userRank, idx) => {
                                                                                return (<MyLeaderboardItem key={idx} contestItem={this.state.contestItem} isExpanded={this.state.isExpandedWithDelay} SelectedLineup={this.state.SelectedLineup} userRank={userRank} index={idx} 
                                                                                    openLineup={this.openLineup} 
                                                                                />);
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                                {
                                                                    this.state.userRankList.length > 1 && <div className={"header-arrow-container" + (this.state.isExpanded ? ' expand' : '')}>
                                                                        <div className="header-arrow-top" />


                                                                        <div className="header-arrow">
                                                                            <div id="pentagon" onClick={() => {
                                                                                this.setState({ isExpanded: !this.state.isExpanded })
                                                                                setTimeout(() => {
                                                                                    this.setState({ isExpandedWithDelay: this.state.isExpanded })
                                                                                }, 0);
                                                                            }}>
                                                                                <i className={"icon-" + (this.state.isExpanded ? "arrow-up" : "arrow-down")} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className={"spacing-wrapper" + (this.state.userRankList.length > 1 ? ' grey-clr' : ' ')}></div>
                                                            </Fragment>
                                                        }
                                                        <ListHeader context={this} />
                                                    </div>
                                                    <div className={'p-height' + (this.state.status != 1 ? ' completed': '' )+ (this.state.isExpanded ? this.state.status == 1 ? ' expand':' expand-completed': '') + (this.state.userRankList.length > 1 ? '' : this.state.status == 1 ? ' no-arrow': ' no-arrow-completed')} id='scrollableTarget'>
                                                        <InfiniteScroll
                                                            dataLength={this.state.leaderboardList.length}
                                                            pullDownToRefreshThreshold={300}
                                                            refreshFunction={this.handleRefresh}
                                                            // pullDownToRefresh={window.ReactNativeWebView || isMobile ? true : false}
                                                            pullDownToRefresh={false}
                                                            next={() => this.onLoadMore()}
                                                            hasMore={!this.state.isLoaderShow && this.state.hasMore}
                                                            scrollableTarget={'scrollableTarget'}
                                                            loader={
                                                                this.state.isLoadMoreLoaderShow &&
                                                                <h4 className='table-loader'>{AppLabels.LOADING_MSG}</h4>
                                                            }
                                                            pullDownToRefreshContent={
                                                                window.ReactNativeWebView || isMobile &&
                                                                <h3 style={{ textAlign: 'center', fontSize: 14 }}>&#8595; {AppLabels.PULL_DOWN_TO_REFRESH}</h3>
                                                            }
                                                            releaseToRefreshContent={
                                                                window.ReactNativeWebView || isMobile &&
                                                                <h3 style={{ textAlign: 'center', fontSize: 14 }}>&#8593; {AppLabels.RELEASE_TO_REFRESH}</h3>
                                                            }>
                                                            <div className="leaderboard-listing">

                                                                {_Map(this.state.leaderboardList, (item, idx) => {

                                                                    return (
                                                                        <div key={item.lineup_master_contest_id} 
                                                                            onClick={(e) => this.openLineup(e,item,2, true)} 
                                                                            className={"ranking-list pointer-cursor " + (this.state.SelectedLineup == item.lineup_master_contest_id ? ' sel-active' : '')}>
                                                                            <div className="display-table-cell text-center">
                                                                                <div className="rank">{item.game_rank}</div>
                                                                                <div className="rank-heading">{AppLabels.RANK}</div>
                                                                            </div>
                                                                            <div className="display-table-cell pl-1">

                                                                                <div className="user-name-container">
                                                                                    <div className="user-name">{item.user_name}</div>
                                                                                    <div className="user-team-name">
                                                                                        {

                                                                                            <span className="won-amount">
                                                                                                {
                                                                                                    item.prize_data && item.prize_data.length > 0 ?

                                                                                                        _Map(item.prize_data, (prizeItem, idx) => {

                                                                                                            return (

                                                                                                                (prizeItem.prize_type == 0) ?
                                                                                                                    <span className="contest-prizes"   >
                                                                                                                        {<i style={{ display: 'inlineBlock' }} className="icon-bonus"></i>}
                                                                                                                        {item.prize_data.length === idx + 1 ? Number(parseFloat(prizeItem.amount || 0).toFixed(2)) : Number(parseFloat(prizeItem.amount || 0).toFixed(2)) + "/"}
                                                                                                                    </span>
                                                                                                                    :
                                                                                                                    (prizeItem.prize_type == 1) ?
                                                                                                                        <span className="contest-prizes">

                                                                                                                            {<span style={{ display: 'inlineBlock' }}>{Utilities.getMasterData().currency_code}</span>}
                                                                                                                            {item.prize_data.length === idx + 1 ? Number(parseFloat(prizeItem.amount || 0).toFixed(2)) : Number(parseFloat(prizeItem.amount || 0).toFixed(2)) + "/"}
                                                                                                                        </span>
                                                                                                                        :
                                                                                                                        (prizeItem.prize_type == 2) ?
                                                                                                                         <span className="contest-prizes">
                                                                                                                                {<span style={{ display: 'inlineBlock' }}>
                                                                                                                                <img style={{ marginBottom: '2px' }} src={Images.IC_COIN} width="12px" height="12px" />
                                                                                                                                    {item.prize_data.length === idx + 1 ? prizeItem.amount : prizeItem.amount + "/"}</span>}

                                                                                                                            </span>
                                                                                                                            :
                                                                                                                            (prizeItem.prize_type == 3) ?
                                                                                                                                <span className="contest-prizes" >
                                                                                                                                    {<span style={{ display: 'inlineBlock' }}>{item.prize_data.length === idx + 1 ? prizeItem.name : prizeItem.name + "/"}</span>}

                                                                                                                                </span> : ''



                                                                                                            )


                                                                                                        })
                                                                                                        :
                                                                                                        item.won_prize != "" &&
                                                                                                        <span className="won-amount">
                                                                                                            {this.state.contestItem.prize_type == 1 &&
                                                                                                                <React.Fragment>
                                                                                                                    {Utilities.getMasterData().currency_code}
                                                                                                                    {Number(parseFloat(item.won_prize || 0).toFixed(2))}
                                                                                                                    <span className="won"> {AppLabels.WON} - </span>
                                                                                                                </React.Fragment>
                                                                                                            }
                                                                                                            {this.state.contestItem.prize_type == 0 &&
                                                                                                                <React.Fragment>
                                                                                                                    <i className="icon-bonus"></i>
                                                                                                                    {Number(parseFloat(item.won_prize || 0).toFixed(2))}
                                                                                                                    <span className="won">{AppLabels.WON} - </span>
                                                                                                                </React.Fragment>
                                                                                                            }

                                                                                                        </span>}

                                                                                            </span>
                                                                                        }
                                                                                        {item.prize_data && item.prize_data.length > 0 ? <React.Fragment>

                                                                                            <span style={{ color: '#5DBE7D' }} className="won"> {AppLabels.WON} -  </span>{item.team_name}
                                                                                        </React.Fragment> : " " + item.team_name
                                                                                        }
                                                                                    </div>
                                                                                </div>

                                                                                {/* <a href onClick={(e)=>this.TeamComparison(e,'',item)}>Comparison</a> */}
                                                                            </div>
                                                                            <div className="display-table-cell">
                                                                                <div className="points">{item.total_score}</div>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })}

                                                            </div>

                                                        </InfiniteScroll>
                                                    </div>


                                                </div>
                                    }
                                    {
                                        <div className={"refresh-list" + (this.state.isRefresh ? ' rotate' : '')} onClick={this.handleRefresh}>
                                            <i className="icon-return" />
                                        </div>
                                    }
                                </div>
                            </Col>
                        </Row>

                        {
                            (this.state.userRankList.length > 0 || this.state.leaderboardList.length > 0) &&
                            <div className="bottom-download-container">

                                <div onClick={() => this.onDownloadClick()} >
                                    <i className="icon-download-circle" />
                                    <span className="download-text text-uppercase"> {AppLabels.DOWNLOAD_ALL_TEAMS}</span>
                                </div>
                                {this.state.mfileURL != '' && this.state.downloadFail &&
                                    <div onClick={() => this.copyToClipboard(this.state.mfileURL)} >
                                        <span className="download-text text-uppercase" style={{ fontSize: 10 }}>{AppLabels.IN_CASE_AUTO_DOWNLOAD_NOT_START}</span>
                                    </div>
                                }

                            </div>
                        }
                        {
                            this.state.SelectedLineup && <FieldView
                                SelectedLineup={lineupData ? lineupData.lineup : ''}
                                MasterData={lineupData || ''}
                                isFrom={'rank-view'}
                                team_name={lineupData ? (lineupData.team_info.team_name || '') : ''}
                                showFieldV={this.state.showFieldV}
                                IsNetworkGameContest={this.state.IsNetworkGameContest}
                                userName={this.state.UserName}
                                hideFieldV={this.hideFieldV.bind(this)}
                                league_id={this.state.contestItem.league_id}
                            />
                        }
                    </div>
                )}
            </MyContext.Consumer>
        )
    }
}
